import { sb } from './supabase.ts';

/** Check if user is authenticated */
export async function checkAuthentication(): Promise<boolean> {
  const path = window.location.pathname || '/';
  const isOtherSchoolRoute = path === '/other_school_dashboard' || path.startsWith('/other_school/');

  if (isOtherSchoolRoute) {
    try {
      const adminButton = localStorage.getItem('adminButton');
      const adminLastActivity = Number(localStorage.getItem('adminLastActivity') || 0);
      const now = Date.now();
      const timeout = 30 * 60 * 1000; // 30 mins
      if (adminButton && adminLastActivity && (now - adminLastActivity) <= timeout) {
        // Valid school operator session, refresh activity
        localStorage.setItem('adminLastActivity', String(now));
        return true;
      }
    } catch (e) {
      console.error(e);
    }
  }

  const { data: { session }, error } = await sb.auth.getSession();
  if (error || !session) {
    window.location.href = '/login';
    return false;
  }
  return true;
}

/** Listen for auth changes */
export function setupAuthListener(): void {
  sb.auth.onAuthStateChange((event, session) => {
    console.log('Auth event:', event);
    if (event === 'SIGNED_OUT') {
      window.location.href = '/login';
    } else if (event === 'SIGNED_IN' && session) {
      console.log('Valid session found for user:', session.user.email);
    }
  });
}

/** Monitor session and logout on inactivity */
export function startSessionMonitor(): void {
  const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 mins
  let timer: any;

  function reset() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const wasSchool = !!localStorage.getItem('adminButton');
      localStorage.removeItem('adminButton');
      localStorage.removeItem('adminLoginAt');
      localStorage.removeItem('adminLastActivity');

      if (wasSchool) {
        window.location.href = '/other_school/login';
      } else {
        sb.auth.signOut().then(() => {
          window.location.href = '/login';
        });
      }
    }, INACTIVITY_TIMEOUT);
  }

  ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'].forEach(e => {
    document.addEventListener(e, reset, true);
  });
  reset();
}
